var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 9C3.5 8.17157 4.17157 7.5 5 7.5H20C20.8284 7.5 21.5 8.17157 21.5 9V19.5C21.5 20.3284 20.8284 21 20 21H5C4.17157 21 3.5 20.3284 3.5 19.5V9ZM20 9H5V19.5H20V9Z",
    fill: "#cda742"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 2.25C11.8038 2.25 11.1361 2.52656 10.6438 3.01884C10.1516 3.51113 9.875 4.17881 9.875 4.875V8.25C9.875 8.66421 9.53921 9 9.125 9C8.71079 9 8.375 8.66421 8.375 8.25V4.875C8.375 3.78098 8.8096 2.73177 9.58318 1.95818C10.3568 1.1846 11.406 0.75 12.5 0.75C13.594 0.75 14.6432 1.1846 15.4168 1.95818C16.1904 2.73177 16.625 3.78098 16.625 4.875V8.25C16.625 8.66421 16.2892 9 15.875 9C15.4608 9 15.125 8.66421 15.125 8.25V4.875C15.125 4.17881 14.8484 3.51113 14.3562 3.01884C13.8639 2.52656 13.1962 2.25 12.5 2.25Z",
    fill: "#cda742"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.375C13.1213 15.375 13.625 14.8713 13.625 14.25C13.625 13.6287 13.1213 13.125 12.5 13.125C11.8787 13.125 11.375 13.6287 11.375 14.25C11.375 14.8713 11.8787 15.375 12.5 15.375Z",
    fill: "#cda742"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/Privacy.306e731f82c5f9253af410db40918615.svg";
export { ForwardRef as ReactComponent };